var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNavbarBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M12.5,14.063A7.031,7.031,0,1,0,5.469,7.031,7.033,7.033,0,0,0,12.5,14.063Zm6.25,1.563H16.06a8.5,8.5,0,0,1-7.119,0H6.25A6.25,6.25,0,0,0,0,21.875v.781A2.344,2.344,0,0,0,2.344,25H22.656A2.344,2.344,0,0,0,25,22.656v-.781A6.25,6.25,0,0,0,18.75,15.625Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNavbarBlanco);
export default __webpack_public_path__ + "static/media/user-navbar-blanco.5a3fb5fb97ef3f940f80c46dd87a4653.svg";
export { ForwardRef as ReactComponent };